exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".author__name[data-v-0806dae8]{text-align:center}.quote-author[data-v-0806dae8]{margin-top:1.25rem;letter-spacing:.04688rem;font-size:.8125rem;line-height:1;font-weight:600;color:#000}@media screen and (min-width:48em){.quote-author[data-v-0806dae8]{font-size:1.25rem;letter-spacing:.0625rem;margin-top:2.625rem}}@media screen and (min-width:75em){.quote-author[data-v-0806dae8]{margin-top:3.625rem}}", ""]);

// exports
